<!--
 * @Author: your name
 * @Date: 2020-09-19 10:15:05
 * @LastEditTime: 2020-09-22 09:44:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\children\MultimediaItem.vue
-->
<template>
  <div class="card" :class="{'card-select': cardSelect === cardData.id}" @click="$emit('mediaSelect',cardData.id)">
    <div class="content" @click="$emit('selectChange',cardData)">
      <img :src="srcUrl" :alt="cradName" />
    </div>
    <div class="title">
      <div class="time">
        <span v-if="cardType === '1'">{{cradTime | timeLength}}</span>
      </div>
      <div class="name">
        <p>{{cradName}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: () => { }
    },
    cardSelect: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      srcUrl: this.cardData.ref_thumb_url,
      cradName: this.cardData.ref_name,
      cradTime: this.cardData.ref_time,
      cardType: this.cardData.type
    };
  },
  filters: {
    timeLength(time) {
      time = parseInt(time / 1000);
      let s = time % 60;
      let m = parseInt(time / 60) % 60;
      let h = parseInt(time / 60 / 60);
      return `${h < 10 ? ('0' + h) : (h)}:${m < 10 ? ('0' + m) : (m)}:${s < 10 ? ('0' + s) : (s)}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-select {
  // border: 2px solid #35cafa;
  box-shadow: 0 0px 4px 2px #35cafa;
}
.card {
  width: 148px;
  height: 115px;
  margin-top: 12px;
  box-sizing: border-box;
  overflow: hidden;
  .content {
    width: 100%;
    height: 83px;
    overflow: hidden;
    img {
      width: 100%;
      height: 83px;
    }
  }
  .title {
    width: 100%;
    height: 32px;
    background-color: #eefbff;
    position: relative;
    .time {
      position: absolute;
      top: -18px;
      right: 2px;
      color: #fff;
      span {
        background: rgba($color: #000000, $alpha: 0.2);
      }
    }
    .name {
      padding: 0px 6px;
      p {
        width: 136px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap; /*加宽度width属来兼容部分浏览*/
      }
    }
  }
}
</style>
